import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import Input from 'components/fields/Input/Input';
import FileInput from 'components/fields/file/fileInput';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { Confirmation, initialConfirmationState } from 'schemas';
import { GeneralFetch } from 'Api/generalFetch/generalFetch';
import { getYearNmonth } from 'utils/common/getYearNMonth';
import { Checkbox, FormControlLabel } from '@mui/material';
import { DrawerSchema, initialDrawerState } from 'schemas';
import { RefetchData } from 'schemas';

const Dialog = ({ setLoad, open, setOpen, details, other, bestNearMiss, setBest, setRefetch, refetch }) => {
    const [formData, setFormData] = useState({});
    const [confirmation, setOpenConfirm] = useRecoilState(Confirmation)
    const { fetchData } = GeneralFetch()
    const setOpenDrawer = useSetRecoilState(DrawerSchema)
    const setRefetchTable = useSetRecoilState(RefetchData)
    const yearNmonth = getYearNmonth(new Date())
    const plainOptions = [
        {
            value: `${yearNmonth.month}-${yearNmonth.year}`,
            label: `Best para o mês de ${yearNmonth.month} de ${yearNmonth.year}`
        },
        {
            value: yearNmonth.year,
            label: `Best para o ano de ${yearNmonth.year}`
        },
    ];

    const onChange = (id, content) => setFormData(prev => ({ ...prev, [id]: content }))

    const onCheck = (value) => {
        const id = yearNmonth.month === value?.target?.id ? 'mes' : 'ano'
        let copy = { ...formData }

        if (copy[id]) {
            const { [id]: _, ...rest } = copy
            setFormData(rest)
        } else {
            const valueChecked = value?.target?.value
            setFormData(prev => ({ ...prev, [id]: valueChecked }))
        }
    }

    useEffect(() => {
        if (!open || confirmation.confirmed !== true || confirmation.component !== 'close') return

        // Consume the confirmation before starting the request. Otherwise this
        // component can replay the previous action when the next drawer mounts.
        setOpenConfirm(initialConfirmationState)

        const executeConfirmedAction = async () => {
            if (bestNearMiss) {
                setLoad('1')
                setOpen(false)

                try {
                    await fetchData({ ...formData, nearmiss_id: other?.data?.objectId }, 'bestNearMiss', 'post', 'best')
                    setBest(false)
                    setRefetch(current => !current)
                } finally {
                    setLoad(null)
                }
                return
            }

            setLoad(details?.estado)
            setOpen(false)
            const formPayload = new FormData();
            formData?.evidencias?.forEach(file => formPayload.append("evidencias[]", file));
            formPayload.append('object_id', other?.data?.objectId)
            formPayload.append('object', other?.object)
            formPayload.append('estado', details?.estado)
            formPayload.append('evidenciaFecho', 1)
            formPayload.append('obs', formData?.obs ?? '')

            try {
                await fetchData(formPayload, 'updateStatus', 'post', 'updateStatus')
                setOpenDrawer(initialDrawerState)
                setRefetchTable(current => !current)
            } finally {
                setLoad(null)
            }
        }

        void executeConfirmedAction().catch(() => undefined)
    }, [confirmation.confirmed])

    return (
        <Modal
            centered
            open={open}
            onOk={() => setOpenConfirm({ component: "close", open: true, msg: "Tem certeza que deseja concluir a operação?" })}
            onCancel={() => setOpen(false)}
            okText={"Proceder"}
            cancelText={"Cancelar"}
            width={{ xs: '90%', sm: '80%', md: '70%', lg: '60%', xl: '50%', xxl: '40%'}}
        >
            {bestNearMiss && <>
                <h6 style={{ marginTop: "10px" }} >Periodo</h6>
                <div style={{ display: "flex" }} >
                    {
                        plainOptions?.map((ck) => <FormControlLabel key={ck.value} control={<Checkbox id={ck?.value} onChange={(e) => onCheck(e)} />} label={ck?.label} value={ck.value} />)
                    }
                </div>
            </>}

            <h6 style={{ marginTop: "10px" }}  >{`Observações`}</h6>
            <Input
                fieldId={"obs"}
                placeholder={"Observações"}
                multiLine={true}
                rows={4}
                formData={formData}
                type={'text'}
                width={"100%"}
                onChange={onChange}
            />

            {!bestNearMiss && <>
                <h6 style={{ marginTop: "10px" }} >Evidencias</h6>
                <FileInput setFormData={setFormData} showUploadBtn={false} />
            </>}
        </Modal>
    );
};
export default Dialog;
